module.exports = __webpack_public_path__ + "img/address.6c8830a7.png";